import {
  Action,
  Cancel,
  Description,
  Root,
  Title,
  Trigger
} from '@radix-ui/react-alert-dialog'
import * as React from 'react'

import { AlertDialogContent } from './AlertDialogContent'

export const AlertDialog = Object.assign(Root, {
  Description: Description,
  Title: Title,
  Action: Action,
  Cancel: Cancel,
  Content: AlertDialogContent,
  Trigger: Trigger
})

AlertDialog.displayName = 'AlertDialog'
